import { render, staticRenderFns } from "./PopupCouplings.vue?vue&type=template&id=0b8886fc&scoped=true"
import script from "./PopupCouplings.vue?vue&type=script&lang=js"
export * from "./PopupCouplings.vue?vue&type=script&lang=js"
import style0 from "./PopupCouplings.vue?vue&type=style&index=0&id=0b8886fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8886fc",
  null
  
)

export default component.exports